export default __webpack_public_path__ + "images/3a183c28e0b735a0e99d18b470cead2c-boston_mobile.webp";